// extracted by mini-css-extract-plugin
export var contentBody = "_45-9";
export var headerImage = "_45-2";
export var imageButton = "_45-7";
export var imageButtonIcon = "_45-8";
export var imageHeader = "_45-4";
export var imageHeaderText = "_45-5";
export var imageOverlay = "_45-3";
export var imageTitle = "_45-6";
export var imageWrapper = "_45-1";
export var taskList = "_45-a";
export var widget = "_45-0";